import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-move-location',
  templateUrl: './move-location.component.html',
  styleUrls: ['./move-location.component.scss']
})
export class MoveLocationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
